/**
 * stream URL → base64(dataURL) 변환
 */
export async function streamUrlToBase64(streamUrl) {
  const res = await fetch(streamUrl, {
    method: "GET",
    credentials: "include", // 🔥 verifyToken 쿠키 필요하면 유지
  });

  if (!res.ok) {
    throw new Error("이미지 스트림 요청 실패");
  }

  const blob = await res.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // data:image/png;base64,...
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
